import React, { useState } from "react";
import "../assets/css/portfolio.scss";
import "../App.css";
import portfolio from "../assets/portfolio.json";

const statusIcons = {
  live: "fa fa-circle",
  restricted: "fa fa-lock",
  removed: "fa fa-ban",
  beta: "fa fa-flask",
  info: "fa fa-briefcase",
};

const Highlights = ({ items }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`highlights${open ? " highlights--open" : ""}`}>
      <button
        type="button"
        className="highlights-toggle"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        What I built <i className="fa fa-angle-down"></i>
      </button>
      <div className="highlights-body">
        <ul>
          {items.map((h, i) => (
            <li key={i}>{h}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const Portfolio = () => {
  return (
    <section id="projects">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Selected Work</span>
          <h1 className="section-title">Projects</h1>
        </div>
        <div className="pp-container">
          {portfolio.map((work) => (
            <div className="pp-card glass-panel" key={work.name}>
              <div className="pp-img-container">
                <img src={work.img} className="p-img" alt={work.name} />
              </div>
              <div className="card-content">
                <h2 className="title">{work.name}</h2>

                {work.status && (
                  <div className="status-tags">
                    {work.status.map((s, i) =>
                      s.url ? (
                        <a
                          href={s.url}
                          target="_blank"
                          rel="noreferrer"
                          className={`status-tag status-${s.type} status-tag--link`}
                          key={i}
                        >
                          <i className={statusIcons[s.type]}></i>
                          {s.label}
                        </a>
                      ) : (
                        <span className={`status-tag status-${s.type}`} key={i}>
                          <i className={statusIcons[s.type]}></i>
                          {s.label}
                        </span>
                      )
                    )}
                  </div>
                )}

                <p className="desc">{work.desc}</p>

                {work.highlights && <Highlights items={work.highlights} />}

                <div className="tools">
                  {work.tools.map((t, i) => (
                    <span className="tool-tag" key={i}>
                      {t}
                    </span>
                  ))}
                </div>
                <div className="cta">
                  {!work.isMobile && work.link && (
                    <a href={work.link} target="_blank" rel="noreferrer">
                      <button className="btn btn-primary">
                        Visit <i className="fa fa-external-link"></i>
                      </button>
                    </a>
                  )}
                  {work.isMobile &&
                    (work.play_store_link ||
                      work.app_store_link ||
                      work.request_access) && (
                      <div className="mobile-links">
                        {work.play_store_link && (
                          <a href={work.play_store_link} target="_blank" rel="noreferrer">
                            <button className="btn">
                              Play Store <i className="fa fa-android"></i>
                            </button>
                          </a>
                        )}
                        {work.app_store_link && (
                          <a href={work.app_store_link} target="_blank" rel="noreferrer">
                            <button className="btn">
                              App Store <i className="fa fa-apple"></i>
                            </button>
                          </a>
                        )}
                        {work.request_access && (
                          <a href={work.request_access}>
                            <button className="btn btn-primary">
                              Request beta access <i className="fa fa-envelope-o"></i>
                            </button>
                          </a>
                        )}
                      </div>
                    )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
